import { render, staticRenderFns } from "./Tab3.vue?vue&type=template&id=3bc64c1c&scoped=true"
import script from "./Tab3.vue?vue&type=script&lang=js"
export * from "./Tab3.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/pei/parte-k.css?vue&type=style&index=0&id=3bc64c1c&prod&scoped=true&lang=css&external"
import style1 from "./Tab3.vue?vue&type=style&index=1&id=3bc64c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc64c1c",
  null
  
)

export default component.exports